import React, { useEffect } from "react";
import {
  Route,
  Switch,
  useRouteMatch,
  useLocation,
  Redirect,
} from "react-router-dom";
import { RequestCache } from "shared/@hooks/useRequestCache";
import { Auth } from "shared/@auth/Auth";
import Page, { Content, Nav, NavGroup, NavItem } from "shared/Page";
import { useCurrentRoute } from "./shared/@hooks/useCurrentRoute.js";
import { ReactComponent as Info_Center_Icon } from "./NewsAdmin/assests/Info_Center_Icon.svg";
import { ReactComponent as Category_Builder_Icon } from "./NewsAdmin/assests/Category_Builder_Icon.svg";
import { ReactComponent as SSF_Sort_Icon } from "./NewsAdmin/assests/SSF_Sort_Icon.svg";
import { ReactComponent as News_Icon } from "./NewsAdmin/assests/Home_Feed_Admin_Icon (1).svg";
import { NewsAdmin } from "NewsAdmin/NewsAdmin.jsx";

export function Marketing() {
  const { path } = useRouteMatch();
  const { hasPermission } = Auth.useContainer();
  const { setCurrentRoute } = useCurrentRoute();
  const location = useLocation();

  // icon colors
  const styles = (pathname) => {
    return {
      filter: !location.pathname.includes(pathname)
        ? "var(--icon-filter)"
        : "var(--icon-filter-invert",
    };
  };

  return (
    <RequestCache.Provider>
      <Page>
        <Nav>
          <NavGroup title="Marketing">
            {hasPermission("marketing.cms.read") && (
              <NavItem
                to={"https://dev-marketing.wwg.support/marketing/cms"}
                icon={<Info_Center_Icon style={styles("cms")} />}
              >
                CMS
              </NavItem>
            )}
            {hasPermission("marketing.categorybuilder.read") && (
              <NavItem
                to={
                  "https://dev-marketing.wwg.support/marketing/category-builder"
                }
                icon={
                  <Category_Builder_Icon style={styles("category-builder")} />
                }
              >
                Category Builder
              </NavItem>
            )}
            {hasPermission("marketing.categorybuilder.read") && (
              <NavItem
                to={"https://dev-marketing.wwg.support/marketing/ssf-sort"}
                icon={<SSF_Sort_Icon style={styles("ssf-sort")} />}
              >
                SSF Sort
              </NavItem>
            )}

            <NavItem to={`${path}/news`} icon={<News_Icon />}>
              News
            </NavItem>
          </NavGroup>
        </Nav>
        <Content>
          <Switch>
            <Route exact path={path}>
              <Redirect to={`${path}/news`} />
            </Route>

            <Route path={`${path}/news`}>
              <NewsAdmin />
            </Route>
          </Switch>
        </Content>
      </Page>
    </RequestCache.Provider>
  );
}
